<template>
  <b-modal @show="onShow" @hidden="onHidden" ref="modal-container" v-model="modalShow" size="lg" :title="title"
    :static="true" :lazy="true" hide-footer>
    <b-button v-if="!create && canCreateFromTemplate"
      variant="outline-primary" class="mb-3" @click="createFromTemplate">
      <i class="fas fa-copy" aria-hidden="true"></i> Create operator from this template
    </b-button>
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <b-tabs content-class="mt-3">
        <b-tab title="Details" active>
          <template #title>
            Common&nbsp;<i v-if="detailsTabHasError" class="fas fa-exclamation-triangle"></i>
          </template>

          <b-form-group label="Name" label-for="name-input">
            <b-form-input id="name-input" name="name-input" v-model="formValues.name"
              v-validate="{ required: true, min: 3, max: 40, minTrimmedLength: [3] }"
              :state="validateState('name-input')" aria-describedby="name-input-live-feedback" data-vv-as="Name"
              data-vv-delay="100" autocomplete="off" />
            <b-form-invalid-feedback id="name-input-live-feedback">
              {{ veeErrors.first('name-input') }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Secret" label-for="secret-input">
            <b-form-input id="secret-input" name="secret-input" v-model="formValues.secret" disabled />
          </b-form-group>

          <b-form-group label="General operator id" label-for="general-operator-id-input">
            <b-form-input id="general-operator-id-input" name="general-operator-id-input"
              v-model="formValues.generalOperatorId" disabled />
          </b-form-group>

          <b-form-group label="Partner" label-for="group-input">
            <b-form-select v-model="formValues.partnerGroupId" :options="partnerOptions"
              :disabled="!this.$store.getters['partnersForSelect/loaded']" />
          </b-form-group>

          <b-form-group label="Api version" label-for="api_version-input">
            <b-form-input id="api_version-input" name="api_version-input" v-model="formValues.apiVersion"
              v-validate="{ regex: /^(\d+\.)?(\d+\.)?(\*|\d+)$/ }" :state="validateState('api_version-input')"
              aria-describedby="api_version-input-live-feedback" data-vv-as="Api version" autocomplete="off" />
            <b-form-invalid-feedback id="api_version-input-live-feedback">
              {{ veeErrors.first('api_version-input') }}
            </b-form-invalid-feedback>
          </b-form-group>


          <b-form-group label="ssBrand" label-for="ssBrand-input">
            <b-form-textarea id="ssBrand-input" v-model="ssBrandInput"
              placeholder="Enter values separated by commas"
              rows="3" autocomplete="off" />
          </b-form-group>

          <b-form-group label="ssAuthToken" label-for="ssAuthToken-input">
            <b-form-input id="ssAuthToken-input" v-model="formValues.ssAuthToken" autocomplete="off" />
          </b-form-group>

          <b-form-checkbox v-model="formValues.lobbyWithPublic" :value="true" :unchecked-value="false">Lobby with
            public</b-form-checkbox>
          <b-form-checkbox v-model="formValues.workOnHalfPause" :value="true" :unchecked-value="false">Work on half
            pause</b-form-checkbox>
          <b-form-group>
            <b-form-checkbox v-model="formValues.longRetry" :value="true" :unchecked-value="false">Long
              retry</b-form-checkbox>
            <b-form-checkbox v-model="formValues.disableFullscreen" :value="1" :unchecked-value="0">Disable
              fullscreen</b-form-checkbox>
            <b-form-checkbox v-model="formValues.sendBetInfo" :value="1" :unchecked-value="0">Send bet
              info</b-form-checkbox>
          </b-form-group>
        </b-tab>

        <b-tab title="Lounge room">
          <b-form-group>
            <b-form-checkbox v-model="formValues.loungeRoomOperator" :value="true" :unchecked-value="false"
              :disabled="saveInProgress">Lounge room operator</b-form-checkbox>
          </b-form-group>
          <b-form-group label="TV tables" label-for="tv-tables-input">
            <multiselect id="tv-tables-input" v-model="selectedTvTables" :options="tvTableOptions"
              track-by="value" label="label" :custom-label="option => `${option.label} (${option.value})`"
              :multiple="true" :close-on-select="false" :limit="3" :loading="loadingTvTables"
              :disabled="saveInProgress || !$store.getters['tablesForSelect/loaded']"
              :select-label="''" :deselect-label="''" :selected-label="''" placeholder="Select tables" />
            <div v-if="tvTablesLoadError" class="text-danger mt-1">
              Unable to load TV tables.
              <b-button type="button" size="sm" variant="outline-secondary" @click="loadTvTables"
                title="Reload TV tables" aria-label="Reload TV tables"><i class="fas fa-sync-alt"></i></b-button>
            </div>
          </b-form-group>
        </b-tab>

        <b-tab title="7 mojos">
          <b-form-group v-for="({ id, label }) in ajzUrls" v-bind:key="id" :label="label" :label-for="id + '-input'">
            <b-form-input :id="id + '-input'" v-model="formValues[id]" autocomplete="off" />
          </b-form-group>
        </b-tab>

        <b-tab title="TV BET">
          <b-form-group v-for="({ id, label }) in tvBetUrls" v-bind:key="id" :label="label" :label-for="id + '-input'">
            <b-form-input :id="id + '-input'" v-model="formValues[id]" autocomplete="off" />
          </b-form-group>
        </b-tab>

        <b-tab title="Altente">
          <b-form-group v-for="({ id, label }) in altenteUrls" v-bind:key="id" :label="label"
            :label-for="id + '-input'">
            <b-form-input :id="id + '-input'" v-model="formValues[id]" autocomplete="off" />
          </b-form-group>
        </b-tab>

        <b-tab title="Tom Horm">
          <b-form-group v-for="({ id, label }) in tomHornSettings" v-bind:key="id" :label="label"
            :label-for="id + '-input-tomhorn'">
            <b-form-input :id="id + '-input-tomhorn'" v-model="formValues.tomHornSettings[id]" autocomplete="off" />
          </b-form-group>
        </b-tab>

        <b-tab title="Kolyseo">
          <b-form-group v-for="({ id, label }) in kolyseoSettings" v-bind:key="id" :label="label"
            :label-for="id + '-input-kolyseo'">
            <b-form-input :id="id + '-input-kolyseo'" v-model="formValues.kolyseoSettings[id]" autocomplete="off" />
          </b-form-group>
        </b-tab>

        <b-tab title="Wazdan">
          <b-form-group v-for="({ id, label }) in wazdanSettings" v-bind:key="id" :label="label"
            :label-for="id + '-input-wazdan'">
            <b-form-input :id="id + '-input-wazdan'" v-model="formValues.wazdanSettings[id]" autocomplete="off" />
          </b-form-group>
        </b-tab>

        <b-tab title="Infingame">
          <b-form-group v-for="({ id, label }) in infingameSettings" v-bind:key="id" :label="label"
            :label-for="id + '-input-infingame'">
            <b-form-input :id="id + '-input-infingame'" v-model="formValues.infingameSettings[id]" autocomplete="off" />
          </b-form-group>
        </b-tab>

        <b-tab title="Wanabet">
          <b-form-group v-for="({ id, label }) in rfrankoSettings" v-bind:key="id" :label="label"
            :label-for="id + '-input-wazdan'">
            <b-form-input :id="id + '-input-rfranko'" v-model="formValues.rfrankoSettings[id]" autocomplete="off" />
          </b-form-group>
        </b-tab>

        <b-tab title="1XBET">
          <b-form-group v-for="({ id, label }) in xbetSettings" v-bind:key="id" :label="label"
            :label-for="id + '-input-xbet'">
            <b-form-input :id="id + '-input-xbet'" v-model="formValues.xbetSettings[id]" autocomplete="off" />
          </b-form-group>
        </b-tab>

        <b-tab title="Mancala">
          <div v-for="({ id, label, type }) in mancalaSettings" v-bind:key="id">
            <b-form-group v-if="type === 'boolean'">
              <b-form-checkbox v-model="formValues.mancalaSettings[id]" :value="true" :unchecked-value="false">{{
                label }}</b-form-checkbox>
            </b-form-group>
            <b-form-group v-else :label="label" :label-for="id + '-input-mancala'">
              <b-form-input :id="id + '-input-mancala'" v-model="formValues.mancalaSettings[id]" autocomplete="off" />
            </b-form-group>
          </div>
        </b-tab>

        <b-tab title="Game Beat">
          <div v-for="({ id, label }) in gameBeatSettings" v-bind:key="id">
            <b-form-group :label="label" :label-for="id + '-input-gamebeat'">
              <b-form-input :id="id + '-input-gamebeat'" v-model="formValues.gameBeatSettings[id]" autocomplete="off" />
            </b-form-group>
          </div>
        </b-tab>

        <b-tab title="Yeebet">
          <div v-for="({ id, label }) in yeebetSettings" v-bind:key="id">
            <b-form-group :label="label" :label-for="id + '-input-yeebet'">
              <b-form-input :id="id + '-input-yeebet'" v-model="formValues.yeebetSettings[id]" autocomplete="off" />
            </b-form-group>
          </div>
        </b-tab>

        <b-tab title="API">
          <template #title>
            API&nbsp;<i v-if="apiTabHasError" class="fas fa-exclamation-triangle"></i>
          </template>
          <b-form-group label="API ID" label-for="apiId-input">
            <b-form-input type="number" id="apiId-input" name="apiId-input" v-model="formValues.apiId"
              v-validate="{ required: true }" :state="validateState('apiId-input')"
              aria-describedby="apiId-input-live-feedback" data-vv-as="API ID" autocomplete="off" />
            <b-form-invalid-feedback id="apiId-input-live-feedback">
              {{ veeErrors.first('apiId-input') }}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group label="API Key" label-for="apiKey-input">
            <b-form-input id="apiKey-input" v-model="formValues.apiKey" autocomplete="off" />
          </b-form-group>
          <b-form-group label="API Tom Horn Key" label-for="tomHornPassKey-input">
            <b-form-input id="tomHornPassKey-input" v-model="formValues.tomHornPassKey" autocomplete="off" />
          </b-form-group>
          <b-form-group label="API Public" label-for="public-input">
            <b-form-input id="public-input" name="public-input" v-model="formValues.public"
              v-validate="{ regex: /^[a-zA-Z\d\-_]{6,50}$/ }" :state="validateState('public-input')"
              aria-describedby="public-input-live-feedback" data-vv-as="API Public" autocomplete="off" />
            <b-form-invalid-feedback id="public-input-live-feedback">
              {{ veeErrors.first('public-input') }}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group label="API Salt" label-for="salt-input">
            <b-form-input id="salt-input" name="salt-input" v-model="formValues.salt"
              :state="validateState('salt-input')" aria-describedby="salt-input-live-feedback" data-vv-as="API Salt"
              autocomplete="off" />
            <b-form-invalid-feedback id="salt-input-live-feedback">
              {{ veeErrors.first('salt-input') }}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group label="Use signature" label-for="useSignature-input">
            <b-form-input type="number" id="useSignature-input" name="useSignature-input"
              v-model="formValues.useSignature" :state="validateState('useSignature-input')"
              aria-describedby="useSignature-input-live-feedback" data-vv-as="Use signature" autocomplete="off" />
            <b-form-invalid-feedback id="useSignature-input-live-feedback">
              {{ veeErrors.first('useSignature-input') }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-tab>

        <b-tab title="URLs">
          <b-form-group v-for="({ id, label }) in urls" v-bind:key="id" :label="label" :label-for="id + '-input'">
            <b-form-input :id="id + '-input'" v-model="formValues[id]" autocomplete="off" />
          </b-form-group>
        </b-tab>

        <b-tab title="Settings" v-if="this.create">
          <b-form-group label="Bingo ticket lifetime (days)" label-for="operator-bingo-lifetime">
            <b-form-input id="operator-bingo-lifetime" type="number" min="1" step="1" placeholder="30"
              v-model.number="formValues.settings.bingoTicketLifetimeDays"
              v-validate="{ integer: true, min_value: 1 }" data-vv-name="bingoTicketLifetimeDays"
              data-vv-as="Bingo ticket lifetime" :state="validateState('bingoTicketLifetimeDays')" />
            <b-form-invalid-feedback>{{ veeErrors.first('bingoTicketLifetimeDays') }}</b-form-invalid-feedback>
          </b-form-group>
          <b-alert v-if="isSpainServer && settingsChangedWarning" variant="warning" show class="mb-3">
            <strong>Внимание!</strong> Настройки оператора изменены с дефолтных значений для Испании.
          </b-alert>
          <b-form-group label="Rounds before redirect" label-for="homeUrl-input">
            <b-form-input id="homeUrl-input" type="number" v-model="formValues.settings.redirectAfterRoundsWait"
              autocomplete="off" placeholder="Enter number of rounds" />
          </b-form-group>
          <b-form-group>
            <b-form-checkbox v-model="formValues.settings.sendBetDetails" :value="true" :unchecked-value="false">Send
              bet details</b-form-checkbox>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox v-model="formValues.settings.enableMinAdjust" :value="true" :unchecked-value="false">Enable
              min adjust</b-form-checkbox>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox v-model="formValues.settings.enableMaxAdjust" :value="true" :unchecked-value="false">Enable
              max adjust</b-form-checkbox>
          </b-form-group>
          <b-form-group label="Hide controls" label-for="sources-input">
            <multiselect id="filter-type" v-model="chosenHideControls" :options="hideControlsOptions"
              :custom-label="(opt) => opt.value" track-by="value" :multiple="true" :placeholder="$t('Select')"
              :select-label="$t('Press enter to select')" :selected-label="$t('Selected')" :hide-selected="true" />
          </b-form-group>
          <HideControlsMapEditor v-model="formValues.settings.hideControlsMap" :controls="hideControlsOptions.map(option => option.value)" />
          <b-form-group>
            <b-form-checkbox v-model="formValues.settings.disableNumberCompact" :value="true"
              :unchecked-value="false">Disable
              number compact</b-form-checkbox>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox v-model="formValues.settings.showTimeZone" :value="true" :unchecked-value="false">Show
              timezone (UTC)</b-form-checkbox>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox v-model="formValues.settings.disableOppositeBets" :value="true"
              :unchecked-value="false">Disable
              opposite bets</b-form-checkbox>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox v-model="formValues.settings.showWorking" :value="true" :unchecked-value="false">Show
              working</b-form-checkbox>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox v-model="formValues.settings.rollReverse" :value="true" :unchecked-value="false">Roll
              reverse lobby</b-form-checkbox>
          </b-form-group>

          <b-form-group>
            <b-form-checkbox v-model="formValues.settings.adjustComboBets" :value="true" :unchecked-value="false">Adjust
              combo bets to a maximum</b-form-checkbox>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox v-model="formValues.settings.groupCredit" :value="true" :unchecked-value="false">Group
              credit</b-form-checkbox>
          </b-form-group>
          <!-- <b-form-group>
            <b-form-checkbox v-model="formValues.sendIsMobile" :value="true" :unchecked-value="false">Is Mobile</b-form-checkbox>
          </b-form-group> -->
          <b-form-group label="Partner logo" label-for="partnerLogo-input">
            <div style="max-width: 200px" class="mb-2" v-if="formValues.logo">
              <b-img :src="makeLogoPath(formValues.logo)" fluid alt="Logo"></b-img>
            </div>

            <b-form-file v-model="logo"
              v-validate="{ image: true, size: 150, maxDimensions: [660, 300], maxWidthHeightRatio: 2 }"
              id="partnerLogo-input" name="partnerLogo-input" :state="validateState('partnerLogo-input')"
              aria-describedby="partnerLogo-input-live-feedback" data-vv-as="Partner logo" no-drop
              placeholder="Choose a file here..." />
            <b-form-invalid-feedback id="partnerLogo-input-live-feedback">
              {{ veeErrors.first('partnerLogo-input') }}
            </b-form-invalid-feedback>
          </b-form-group>


        </b-tab>

        <b-tab title="Skin Map">
          <b-form-group label="Skin">
            <b-form-select v-model="formValues.skin"
              :options="[
                { text: '', value: null },
                { text: 'alg2', value: 'alg2' },
              ]" />
          </b-form-group>
          <div v-for="item in formValues.skinMap" v-bind:key="item.tableId" class="row mb-2">
            <div class="col-sm-4">
              <b-form-select v-model="item.tableId" :options="tableListForSkinMap" />
            </div>
            <div class="col-sm-4">
              <b-form-select v-model="item.type"
                :options="[{ text: 'alg2', value: 'alg2' }, { text: 'spp', value: 'spp' }]" />
            </div>
            <div class="col-sm-4">
              <button type="button" class="btn btn-danger" v-on:click.prevent="removeSkinMap(item.tableId)"><i
                  class="fas fa-trash"></i> Remove</button>
            </div>
          </div>

          <div>
            <button type="button" class="btn btn-info" v-on:click.prevent="addSkinMap">Add</button>
          </div>

        </b-tab>

        <b-tab title="Lobby settings" v-if="this.create">
          <b-form-group>
            <b-form-checkbox v-model="useDefaultSettingsForLobby" :value="true" :unchecked-value="false">Use default
              settings</b-form-checkbox>
          </b-form-group>

          <b-form-group label="Tables:">
            <div class="border rounded" :class="{ 'draggable-disabled': useDefaultSettingsForLobby }">
              <draggable v-model="lobbyTables" group="tables" @start="drag = true" @end="drag = false"
                :disabled="useDefaultSettingsForLobby" class="row m-1">
                <div v-for="table in actualLobbyTables" :key="table.id" class="btn-group p-1 col-sm-3" role="group">
                  <div class="btn btn-secondary btn-sm text-ellipsis">
                    <small>{{ table.title }}</small>
                  </div>
                  <button v-if="useDefaultSettingsForLobby === false" type="button" class="btn btn-secondary btn-sm"
                    v-on:click="removeLobbyTable(table.id)" style="flex-grow: initial;">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <div class="col-sm-3 p-1">
                  <b-form-select :disabled="useDefaultSettingsForLobby || tableListForLobbyTables.length <= 1"
                    v-model="lobbyTablesAddValue" :options="tableListForLobbyTables" size="sm"
                    v-on:change="addLobbyTable" />
                </div>

              </draggable>

            </div>
          </b-form-group>

          <b-form-group label="Table Types:">
            <div class="border rounded" :class="{ 'draggable-disabled': useDefaultSettingsForLobby }">
              <draggable v-model="lobbyTableGroups" group="tableTypes" @start="drag = true" @end="drag = false"
                :disabled="useDefaultSettingsForLobby" class="row m-1">
                <div v-for="group in actualLobbyTableGroups" :key="group" class="btn-group p-1 col-sm-3" role="group">
                  <div class="btn btn-secondary btn-sm text-ellipsis">
                    <small>{{ group }}</small>
                  </div>
                  <button v-if="useDefaultSettingsForLobby === false" type="button" class="btn btn-secondary btn-sm"
                    v-on:click="removeLobbyTableGroup(group)" style="flex-grow: initial;">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <div class="col-sm-3 p-1">
                  <b-form-select :disabled="useDefaultSettingsForLobby || tableGroupList.length <= 1"
                    v-model="lobbyTableGroupsAddValue" :options="tableGroupList" size="sm"
                    v-on:change="addLobbyTableGroup" />
                </div>

              </draggable>
            </div>
          </b-form-group>
          <b-form-group>
            <button type="button" :disabled="useDefaultSettingsForLobby" class="btn btn-default"
              v-on:click="copyLobbySettings"><i class="fa fa-copy"></i> Copy</button>
            <button type="button" :disabled="useDefaultSettingsForLobby" class="btn btn-default ml-2"
              v-on:click="pasteLobbySettings"><i class="fa fa-paste"></i> Paste</button>
          </b-form-group>
        </b-tab>

        <b-tab title="Max Coverage" v-if="this.create">
          <b-form-group label="Default value">
            <b-form-input id="maxCoverage-input" type="number" v-model="formValues.settings.maxCoverage"
              autocomplete="off" placeholder="Max Coverage" />
          </b-form-group>

          <div class="row" v-if="maxCoverageItems.length > 0">
            <div class="col-sm-4">
              <label>Table ID</label>
            </div>
            <div class="col-sm-4">
              <label>Max Coverage</label>
            </div>
          </div>

          <div v-for="(item, key) in maxCoverageItems" v-bind:key="key" class="row mb-2">
            <div class="col-sm-4">
              <b-form-input type="number" v-model="item.tableId" placeholder="Table ID" />
            </div>
            <div class="col-sm-4">
              <b-form-input type="number" v-model="item.value" placeholder="Max Coverage" />
            </div>
            <div class="col-sm-4">
              <button type="button" class="btn btn-danger" v-on:click.prevent="removeMaxCoverage(key)"><i
                  class="fas fa-trash"></i> Remove</button>
            </div>
          </div>

          <div>
            <button type="button" class="btn btn-info" v-on:click.prevent="addMaxCoverage">Add value for table</button>
          </div>

        </b-tab>

      </b-tabs>
    </form>

    <b-button class="mt-2 float-right" variant="primary" @click="handleSubmit"
      :disabled="this.saveInProgress || !this.$store.getters['partnersForSelect/loaded']">Save</b-button>
  </b-modal>
</template>
<style>
.sortable-ghost {
  opacity: 0.5;
}

.draggable-disabled {
  background-color: #ececec;
}

.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<script>
import { getRouteIcon, ROUTE_OPERATORS } from '@/utils/routerIcons'
import Multiselect from 'vue-multiselect'
import HideControlsMapEditor from '../HideControlsMapEditor.vue'
import draggable from 'vuedraggable'
import Vue from 'vue'
import _ from 'lodash'
import { ADMIN } from '@/definitions/Roles'

const tableTypes = [
  'Roulette',
  'AutomaticRoulette',
  'CroupierRoulette',
  'Cards',
  'Baccarat',
  'BlackJack',
  'Poker'
];

export default {
  data() {
    return {
      create: false,
      title: '',
      defaultValues: {},
      defaultSettings: {},
      useDefaultSettingsForLobby: true,
      lobbyTablesAddValue: 0,
      lobbyTableGroupsAddValue: 0,
      lobbyTables: [],
      lobbyTableGroups: [],
      maxCoverageItems: [],

      urls: [
        { id: 'creditUrl', label: 'Credit url' },
        { id: 'debitUrl', label: 'Debit url' },
        { id: 'getBalanceUrl', label: 'Get balance url' },
        { id: 'rollbackUrl', label: 'Rollback url' },
        { id: 'authUrl', label: 'Auth url' },
        { id: 'homeUrl', label: 'Home url' },
      ],
      tvBetUrls: [
        { id: 'tvPromoUrl', label: 'Promo url' },
        { id: 'tvClientId', label: 'Client id' },
        { id: 'tvIframe', label: 'Iframe link' },
        { id: 'tvKey', label: 'Tv key' },
      ],
      ajzUrls: [
        { id: 'ajzToken', label: 'Ajz token' },
        { id: 'ajzHost', label: 'Ajz host' },
        { id: 'ajzFrontLink', label: 'Ajz front link' },
        { id: 'ajzLiveFrontLink', label: 'Ajz live front link' },
        { id: 'ajzLobbyHost', label: 'Ajz lobby host' },
        { id: 'ajzLiveHost', label: 'Ajz live host' },
        { id: 'ajzLiveToken', label: 'Ajz live token' },
      ],
      altenteUrls: [
        { id: 'altServer', label: 'Altente server' },
        { id: 'altToken', label: 'Altente token' },
        { id: 'altSecret', label: 'Altente secret' },
      ],
      tomHornSettings: [
        { id: 'server', label: 'Server' },
        { id: 'partner', label: 'Partner' },
        { id: 'secret', label: 'Secret' },
      ],
      kolyseoSettings: [
        { id: 'casinoUID', label: 'Casino UID' },
        { id: 'url', label: 'Url' },
      ],
      infingameSettings: [
        { id: 'infinSession', label: 'infinSession' },
      ],
      wazdanSettings: [
        { id: 'code', label: 'code' },
        { id: 'partner', label: 'Partner' },
        { id: 'url', label: 'Url' },
        { id: 'license', label: 'License' },
        { id: 'serviceUrl', label: 'Service URL' },
      ],
      rfrankoSettings: [
        { id: 'apiUrl', label: 'API URL' },
        { id: 'secretKey', label: 'Secret key' },
        { id: 'operatorUID', label: 'Operator UID' },
        { id: 'partnerUID', label: 'Partner UID' },
        { id: 'systemUID', label: 'System UID' },
      ],
      xbetSettings: [
        { id: 'url', label: 'URL' },
        { id: 'mobileUrl', label: 'Mobile URL' },
        { id: 'backSecret', label: 'Back Secret' },
        { id: 'frontSecret', label: 'Front Secret' },
        { id: 'cyberType', label: 'Cyber Type', type: 'int' },
      ],
      mancalaSettings: [
        { id: 'url', label: 'Url' },
        { id: 'brand', label: 'Brand' },
        { id: 'clientGuid', label: 'Client GUID' },
        { id: 'clientKey', label: 'Client Key' },
        { id: 'isVirtual', label: 'Is Virtual', type: 'boolean' },
      ],
      gameBeatSettings: [
        { id: 'casinoID', label: 'Casino ID' },
        { id: 'authToken', label: 'Auth Token' },
        { id: 'providerUrl', label: 'Provider URL' },
      ],
      yeebetSettings: [
        { id: 'url', label: 'url' },
        { id: 'appId1', label: 'APP ID 1' },
        { id: 'secret1', label: 'Secret 1' },
        { id: 'appId2', label: 'APP ID 2' },
        { id: 'secret2', label: 'Secret 2' },
        { id: 'appIdSeamless', label: 'APP ID Seamless' },
        { id: 'secretSeamless', label: 'Secret Seamless' },
        { id: 'authMode', label: 'Auth Mode (1/2/3)', type: 'int' },
      ],
      modalShow: false,
      formValues: this.getInitialValues(),
      logo: null,
      chosenHideControls: [],
      formSettings: this.getInitialSettings(),
      saveInProgress: false,
      loadingTvTables: false,
      tvTablesLoadError: false,
      isSpainServer: false,
      ssBrandInput: '',
      spainDefaultSettings: null,
      settingsChangedWarning: false,
    }
  },
  components: {
    HideControlsMapEditor,
    Multiselect,
    draggable
  },
  props: {
  },
  methods: {
    createFromTemplate() {
      const sourceId = this.formValues.id;
      this.hideModal();
      this.$emit('create-template', sourceId);
    },
    copyLobbySettings() {
      window.localStorage.setItem('buffer', JSON.stringify({
        lobbyTables: this.lobbyTables,
        lobbyTableGroups: this.lobbyTableGroups
      }));
      this.$toastr.i('Copied');
    },
    pasteLobbySettings() {
      try {
        let settings = JSON.parse(window.localStorage.getItem('buffer'));
        if (!Object.prototype.hasOwnProperty.call(settings, 'lobbyTables') || !Object.prototype.hasOwnProperty.call(settings, 'lobbyTableGroups')) {
          return;
        }

        this.lobbyTables = settings.lobbyTables;
        this.lobbyTableGroups = settings.lobbyTableGroups;
        this.$toastr.i('Pasted');
      } catch (e) {
        console.warn(e)
        return;
      }


    },
    addLobbyTable(tableId) {
      if (tableId === 0) {
        return;
      }

      let table = this.$store.getters['tablesForSelect/list'].filter(({ value }) => value === tableId)[0];
      if (!table) {
        return;
      }
      this.lobbyTables.push({ id: table.value, title: table.value + ' - ' + table.label });
      this.lobbyTablesAddValue = 0;
    },
    addLobbyTableGroup(group) {
      if (group === 0) {
        return;
      }

      if (tableTypes.indexOf(group) === -1) {
        return;
      }

      this.lobbyTableGroups.push(group);
      this.lobbyTableGroupsAddValue = 0;
    },
    removeLobbyTable(tableId) {
      this.lobbyTables = this.lobbyTables.filter((item) => item.id !== tableId);
    },
    removeLobbyTableGroup(group) {
      this.lobbyTableGroups = this.lobbyTableGroups.filter((item) => item !== group);
    },
    removeMaxCoverage(key) {
      this.$delete(this.maxCoverageItems, key)
    },
    addMaxCoverage() {
      this.maxCoverageItems.push({
        tableId: null,
        value: null,
      })
    },
    removeSkinMap(tableId) {
      this.formValues.skinMap = this.formValues.skinMap.filter((item) => item.tableId !== tableId);
    },
    addSkinMap() {
      if (!this.formValues.skinMap) {
        this.formValues.skinMap = [];
      }
      this.formValues.skinMap.push({
        tableId: null,
        type: 'alg2',
      })
    },
    async onShow() {
      this.resetModal();
      await this.loadTvTables();
      await this.loadSpainSettings();
      if (this.isSpainServer && this.create && this.spainDefaultSettings) {
        this.applySpainDefaults();
      }
      this.checkSpainSettingsChanged();
    },
    async loadSpainSettings() {
      try {
        const response = await this.$http.get('/api/v1/operators/default-settings');
        this.isSpainServer = response.data.hasDefaultSettings;
        this.spainDefaultSettings = response.data.defaultSettings;
      } catch (e) {
        this.isSpainServer = false;
        this.spainDefaultSettings = null;
      }
    },
    async loadTvTables() {
      this.loadingTvTables = true;
      this.tvTablesLoadError = false;
      try {
        await this.$store.dispatch('tablesForSelect/loadList');
      } catch (error) {
        this.$store.commit('tablesForSelect/SET_PROMISE', null);
        this.tvTablesLoadError = true;
      } finally {
        this.loadingTvTables = false;
      }
    },
    applySpainDefaults() {
      if (!this.spainDefaultSettings) return;

      // Apply default settings for Spain
      if (this.spainDefaultSettings.adjustLowBalance !== undefined) {
        Vue.set(this.formValues.settings, 'adjustLowBalance', this.spainDefaultSettings.adjustLowBalance);
      }
      if (this.spainDefaultSettings.enableMinAdjust !== undefined) {
        Vue.set(this.formValues.settings, 'enableMinAdjust', this.spainDefaultSettings.enableMinAdjust);
      }
      if (this.spainDefaultSettings.enableMaxAdjust !== undefined) {
        Vue.set(this.formValues.settings, 'enableMaxAdjust', this.spainDefaultSettings.enableMaxAdjust);
      }
      if (this.spainDefaultSettings.hideControls) {
        Vue.set(this.formValues.settings, 'hideControls', [...this.spainDefaultSettings.hideControls]);
        this.chosenHideControls = this.hideControlsOptions.filter(({ value }) =>
          this.spainDefaultSettings.hideControls.includes(value)
        );
      }
    },
    checkSpainSettingsChanged() {
      if (this.create) {
        this.settingsChangedWarning = false;
        return;
      }

      if (!this.isSpainServer || !this.spainDefaultSettings) {
        this.settingsChangedWarning = false;
        return;
      }

      const settings = this.formValues.settings || {};

      const normalizedSettings = { ...settings };
      if (normalizedSettings.enableMinAdjust !== undefined && normalizedSettings.minAjustEnable === undefined) {
        normalizedSettings.minAjustEnable = normalizedSettings.enableMinAdjust;
      }
      if (normalizedSettings.enableMaxAdjust !== undefined && normalizedSettings.maxAjustEnable === undefined) {
        normalizedSettings.maxAjustEnable = normalizedSettings.enableMaxAdjust;
      }

      for (const key in this.spainDefaultSettings) {
        const defaultValue = this.spainDefaultSettings[key];

        const settingValue = normalizedSettings[key];

        if (settingValue === undefined) {
          continue;
        }

        if (key === 'hideControls') {
          const hideControls = this.chosenHideControls
            .map(opt => (opt.value || '').toString().toLowerCase())
            .sort();
          const defaultHideControls = [...(defaultValue || [])]
            .map(value => (value || '').toString().toLowerCase())
            .sort();
          if (JSON.stringify(hideControls) !== JSON.stringify(defaultHideControls)) {
            this.settingsChangedWarning = true;
            return;
          }
          continue;
        }

        if (settingValue !== defaultValue) {
          this.settingsChangedWarning = true;
          return;
        }
      }

      this.settingsChangedWarning = false;
    },
    onHidden() {
      this.resetModal();
      this.$emit('hidden');
    },
    getInitialValues() {
      return {
        name: null,
        secret: null,
        generalOperatorId: null,
        partnerGroupId: null,
        apiVersion: '1.3',
        lobbyWithPublic: "false",
        loungeRoomOperator: false,
        tvTableIds: [],
        workOnHalfPause: "false",
        // method: null,
        // tokenLifeTime: null,
        // nwFrontShow: null,
        // isPre: null,
        // sendIsMobile: null,

        ajzToken: null,
        ajzHost: null,
        ajzFrontLink: null,
        ajzLiveFrontLink: null,
        ajzLobbyHost: null,
        ajzLiveHost: null,
        ajzLiveToken: null,

        tvPromoUrl: null,
        tvClientId: null,
        tvIframe: null,
        tvKey: null,

        altServer: null,
        altToken: null,
        altSecret: null,

        apiId: 0,
        apiKey: null,
        tomHornPassKey: null,
        public: (+new Date()).toString(32) + Math.ceil(Math.random() * 1e9).toString(32) + Math.ceil(Math.random() * 1e9).toString(32),
        salt: (+new Date()).toString(32) + Math.ceil(Math.random() * 1e9).toString(32) + Math.ceil(Math.random() * 1e9).toString(32),
        useSignature: 1,

        creditUrl: null,
        debitUrl: null,
        getBalanceUrl: null,
        rollbackUrl: null,
        authUrl: null,
        homeUrl: null,

        // noBetDetails: null,
        settings: { ...this.getInitialSettings() },
        logo: null,
        disableFullscreen: null,
        sendBetInfo: null,
        skinMap: [],
        skin: null,
        tomHornSettings: {},
        wazdanSettings: {},
        rfrankoSettings: {},
        kolyseoSettings: {},
        infingameSettings: {},
        xbetSettings: {},
        mancalaSettings: {},
        gameBeatSettings: {},
        yeebetSettings: {},
        ssBrand: null,
        ssAuthToken: null
      };
    },
    getInitialSettings() {
      return {
        redirectAfterRoundsWait: 10,
        bingoTicketLifetimeDays: 30,
        sendBetDetails: null,
        enableMinAdjust: null,
        enableMaxAdjust: null,
        disableNumberCompact: null,
        showTimeZone: null,
        disableOppositeBets: null,
        ssBrand: null,
        ssAuthToken: null,
        hideControls: [],
        hideControlsMap: {},
        showWorking: false,
        rollReverse: false,
        maxCoverage: null,
        maxCoverageMap: {},
        adjustComboBets: false,
      };
    },
    setFormValues(values) {
      for (let field in values) {
        if (field === 'settings') {
          continue;
        }

        Vue.set(this.formValues, field, values[field]);
      }
    },
    setFormValuesSettings(settings) {
      for (let setting in settings) {
        Vue.set(this.formSettings, setting, settings[setting]);
      }
    },
    setDefaults() {
      this.setFormValues({ ...this.getInitialValues() });
      this.setFormValues({ ...this.defaultValues });
      this.normalizeOperatorSkinForUi();
      this.normalizeSkinsForUi();
      if (this.create) {
        this.ensureDefaultLobbySkinMap();
      }
      if (this.create) {
        this.formValues.secret = this.generateSecret()
      }
      if (this.create || this.formValues.generalOperatorId === null) {
        this.formValues.generalOperatorId = this.generateGeneralOperatorId()
      }
      this.setFormValuesSettings({ ...this.getInitialSettings() });
      this.setFormValuesSettings({ ...this.defaultSettings });
      this.formValues.settings = { ...this.formSettings };

      const hideControlsLower = (this.formValues.settings.hideControls || []).map(c => (c || '').toString().toLowerCase());
      this.chosenHideControls = this.hideControlsOptions.filter(({ value }) =>
        hideControlsLower.includes((value || '').toString().toLowerCase())
      );

      // Check Spain settings after setting defaults
      this.$nextTick(() => {
        this.checkSpainSettingsChanged();
      });

      this.lobbyTables = [];
      this.lobbyTableGroups = [];
      if (this.defaultValues.lobbyOrderTables) {
        this.defaultValues.lobbyOrderTables.forEach((tableId) => this.addLobbyTable(tableId.toString()));
      }
      if (this.defaultValues.lobbyOrderGroups) {
        this.defaultValues.lobbyOrderGroups.forEach((group) => this.addLobbyTableGroup(group));
      }
      this.useDefaultSettingsForLobby = this.lobbyTables.length === 0 && this.lobbyTableGroups.length === 0;
      this.maxCoverageItems = [];

      if (typeof this.formSettings.maxCoverageMap === 'object' && this.formSettings.maxCoverageMap !== null) {
        for (let tableId in this.formSettings.maxCoverageMap) {
          if (Object.prototype.hasOwnProperty.call(this.formSettings.maxCoverageMap, tableId)) {
            this.maxCoverageItems.push({
              tableId: tableId,
              value: this.formSettings.maxCoverageMap[tableId],
            })
          }
        }
      }

      if (this.formValues.ssBrand) {
        if (Array.isArray(this.formValues.ssBrand)) {
          this.ssBrandInput = this.formValues.ssBrand.join(', ');
        } else {
          this.ssBrandInput = String(this.formValues.ssBrand);
        }
      } else {
        this.ssBrandInput = '';
      }
    },
    normalizeSkinsForUi() {
      if (!Array.isArray(this.formValues.skinMap)) {
        return;
      }

      this.formValues.skinMap.forEach((item) => {
        if (!item || typeof item !== 'object') {
          return;
        }
        if (typeof item.type !== 'string') {
          return;
        }
        const type = item.type.trim();
        if (type === 'alg' || type === 'porto') {
          Vue.set(item, 'type', 'alg2');
        } else {
          Vue.set(item, 'type', type);
        }
      });
    },
    normalizeOperatorSkinForUi() {
      if (this.formValues.skin === null || this.formValues.skin === undefined) {
        return;
      }

      if (typeof this.formValues.skin !== 'string') {
        Vue.set(this.formValues, 'skin', null);
        return;
      }

      const skin = this.formValues.skin.trim();
      if (skin === '') {
        Vue.set(this.formValues, 'skin', null);
        return;
      }

      if (skin === 'alg2') {
        Vue.set(this.formValues, 'skin', 'alg2');
        return;
      }

      if (skin === 'alg' || skin === 'porto') {
        Vue.set(this.formValues, 'skin', 'alg2');
        return;
      }

      Vue.set(this.formValues, 'skin', null);
    },
    ensureDefaultLobbySkinMap() {
      if (!this.create) {
        return;
      }
      if (!Array.isArray(this.formValues.skinMap)) {
        this.formValues.skinMap = [];
      }
      const hasLobby = this.formValues.skinMap.some((item) => item && `${item.tableId}` === '0');
      if (hasLobby) {
        return;
      }
      this.formValues.skinMap.push({
        tableId: 0,
        type: 'alg2',
      });
    },
    generateSecret() {
      let d = new Date().getTime();
      let uuid = 'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });

      return uuid;
    },
    generateGeneralOperatorId() {
      let d = new Date().getTime();
      let uuid = 'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });

      return uuid;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    resetModal() {
      this.setDefaults();
    },
    hideModal() {
      this.modalShow = false;
    },
    show(operator, operatorSettings, isCreate) {
      this.defaultValues = operator
      this.defaultSettings = operatorSettings
      this.create = isCreate;
      this.title = isCreate ? 'Create operator' : `Edit operator: ${operator.name || operator.secret}`
      this.setDefaults();
      this.saveInProgress = false;
      this.modalShow = true;
    },
    handleSubmit() {
      if (this.saveInProgress) {
        return;
      }

      for (let key of Object.keys(this.formValues)) {
        if (typeof this.formValues[key] === 'string') {
          this.formValues[key] = this.formValues[key].trim();
        }
      }

      for (let key of ['altServer']) {
        if (typeof this.formValues[key] === 'string') {
          this.formValues[key] = _.trim(this.formValues[key], '/ ');
        }
      }

      this.normalizeOperatorSkinForUi();
      this.normalizeSkinsForUi();

      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }

        const fd = new FormData();
        if (null !== this.formValues.name) { fd.append('name', this.formValues.name); }
        if (null !== this.formValues.secret) { fd.append('secret', this.formValues.secret); }
        if (null !== this.formValues.generalOperatorId) { fd.append('generalOperatorId', this.formValues.generalOperatorId); }
        if (null !== this.formValues.partnerGroupId) { fd.append('partnerGroupId', this.formValues.partnerGroupId); }
        if (null !== this.formValues.apiVersion) { fd.append('apiVersion', this.formValues.apiVersion); }
        if (null !== this.formValues.lobbyWithPublic) { fd.append('lobbyWithPublic', this.formValues.lobbyWithPublic); }
        fd.append('loungeRoomOperator', this.formValues.loungeRoomOperator === true ? 'true' : 'false');
        fd.append('tvTableIds', JSON.stringify(this.formValues.tvTableIds || []));
        if (null !== this.formValues.workOnHalfPause) { fd.append('workOnHalfPause', this.formValues.workOnHalfPause); }
        if (null !== this.formValues.longRetry) { fd.append('longRetry', this.formValues.longRetry); }
        // if (null !== this.formValues.sendIsMobile) { fd.append('sendIsMobile', this.formValues.sendIsMobile); }

        if (null !== this.formValues.ajzToken) { fd.append('ajzToken', this.formValues.ajzToken); }
        if (null !== this.formValues.ajzHost) { fd.append('ajzHost', this.formValues.ajzHost); }
        if (null !== this.formValues.ajzFrontLink) { fd.append('ajzFrontLink', this.formValues.ajzFrontLink); }
        if (null !== this.formValues.ajzLiveFrontLink) { fd.append('ajzLiveFrontLink', this.formValues.ajzLiveFrontLink); }
        if (null !== this.formValues.ajzLobbyHost) { fd.append('ajzLobbyHost', this.formValues.ajzLobbyHost); }
        if (null !== this.formValues.ajzLiveHost) { fd.append('ajzLiveHost', this.formValues.ajzLiveHost); }
        if (null !== this.formValues.ajzLiveToken) { fd.append('ajzLiveToken', this.formValues.ajzLiveToken); }

        if (null !== this.formValues.tvPromoUrl) { fd.append('tvPromoUrl', this.formValues.tvPromoUrl); }
        if (null !== this.formValues.tvClientId) { fd.append('tvClientId', this.formValues.tvClientId); }
        if (null !== this.formValues.tvIframe) { fd.append('tvIframe', this.formValues.tvIframe); }
        if (null !== this.formValues.tvKey) { fd.append('tvKey', this.formValues.tvKey); }

        if (null !== this.formValues.altServer) { fd.append('altServer', this.formValues.altServer); }
        if (null !== this.formValues.altToken) { fd.append('altToken', this.formValues.altToken); }
        if (null !== this.formValues.altSecret) { fd.append('altSecret', this.formValues.altSecret); }

        if (null !== this.formValues.apiId) { fd.append('apiId', this.formValues.apiId); }
        fd.append('apiKey', this.formValues.apiKey || '');
        fd.append('tomHornPassKey', this.formValues.tomHornPassKey || '');
        if (null !== this.formValues.public) { fd.append('public', this.formValues.public); }
        if (null !== this.formValues.salt) { fd.append('salt', this.formValues.salt); }
        if (null !== this.formValues.useSignature) { fd.append('useSignature', this.formValues.useSignature); }

        if (null !== this.formValues.creditUrl) { fd.append('creditUrl', this.formValues.creditUrl); }
        if (null !== this.formValues.debitUrl) { fd.append('debitUrl', this.formValues.debitUrl); }
        if (null !== this.formValues.getBalanceUrl) { fd.append('getBalanceUrl', this.formValues.getBalanceUrl); }
        if (null !== this.formValues.rollbackUrl) { fd.append('rollbackUrl', this.formValues.rollbackUrl); }
        if (null !== this.formValues.authUrl) { fd.append('authUrl', this.formValues.authUrl); }
        if (null !== this.formValues.homeUrl) { fd.append('homeUrl', this.formValues.homeUrl); }
        if (null !== this.formValues.disableFullscreen) { fd.append('disableFullscreen', this.formValues.disableFullscreen); }
        if (null !== this.formValues.sendBetInfo) { fd.append('sendBetInfo', this.formValues.sendBetInfo); }
        if (null !== this.formValues.skin) { fd.append('skin', this.formValues.skin); }
        if (null !== this.formValues.skinMap) { fd.append('skinMap', JSON.stringify(this.formValues.skinMap)); }

        if (null !== this.formValues.ssAuthToken) { fd.append('ssAuthToken', this.formValues.ssAuthToken); }
        if (this.ssBrandInput !== null && this.ssBrandInput !== '') {
          const values = this.ssBrandInput.split(',').map(v => v.trim()).filter(v => v !== '');
          if (values.length > 0) {
            fd.append('ssBrand', JSON.stringify(values));
          }
        }


        if (this.useDefaultSettingsForLobby) {
          fd.append('lobbyOrderTables', JSON.stringify([]));
          fd.append('lobbyOrderGroups', JSON.stringify([]));
        } else {
          fd.append('lobbyOrderTables', JSON.stringify(this.lobbyTables.map((table) => table.id)));
          fd.append('lobbyOrderGroups', JSON.stringify(this.lobbyTableGroups));
        }

        let maxCoverageMap = {};
        if (this.maxCoverageItems.length > 0) {
          this.maxCoverageItems.forEach((item) => {
            if (!item.tableId || !item.value) {
              return;
            }
            let tableId = parseInt(item.tableId);
            maxCoverageMap[tableId] = parseInt(item.value);
          })
        }

        const settings = {
          ...this.formValues.settings,
          hideControls: this.chosenHideControls.map(opt => opt.value),
          redirectAfterRoundsWait: Number.parseInt(this.formValues.settings.redirectAfterRoundsWait),
          maxCoverageMap,
          maxCoverage: !this.formValues.settings.maxCoverage ? null : parseInt(this.formValues.settings.maxCoverage)
        };
        fd.append('settings', JSON.stringify(settings));

        ['tomHornSettings', 'rfrankoSettings', 'wazdanSettings', 'xbetSettings', 'kolyseoSettings', 'infingameSettings', 'mancalaSettings', 'gameBeatSettings', 'yeebetSettings'].forEach((settingsKey) => {
          this.$data[settingsKey].forEach((item) => {
            let type = item.type ?? 'string';
            let value = this.formValues[settingsKey][item.id];

            if (value === null || value === undefined) {
              return;
            }

            switch (type) {
              case 'int':
                value = value ? parseInt(value) : null;
                break;
            }
            fd.append(settingsKey + '[' + item.id + ']', value);
          });
        });


        if (this.logo) {
          fd.append('logo', this.logo);
        }
        this.saveInProgress = true;
        this
          .$http({
            url: this.create ? '/api/v1/operators' : '/api/v1/operators/' + this.formValues.id,
            data: fd,
            method: 'POST',
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then(() => {
            this.$emit('finish');
            this.hideModal();
            this.$toastr.i('Success');
          })
          .catch((err) => {
            this.$toastr.e(JSON.stringify(err.response.data.message));

            throw err;
          })
          .finally(() => {
            this.saveInProgress = false
          })
      });
    },
    makeLogoPath(path) {
      if (path[0] === '/') {
        return this.cdnBackUrl + path;
      }

      return this.cdnBackUrl + '/' + path;
    }
  },
  computed: {
    tvTableOptions() {
      return this.$store.getters['tablesForSelect/list'] || [];
    },
    selectedTvTables: {
      get() {
        return (this.formValues.tvTableIds || []).map(id => this.tvTableOptions.find(option => Number(option.value) === Number(id))
          || {value: String(id), label: `Table ${id}`});
      },
      set(options) {
        this.formValues.tvTableIds = [...new Set((options || []).map(option => Number(option.value))
          .filter(id => Number.isInteger(id) && id > 0))];
      }
    },
    canCreateFromTemplate() {
      return this.$store.getters.currentUser && this.$store.getters.currentUser.type === ADMIN;
    },
    actualLobbyTables() {
      if (!this.useDefaultSettingsForLobby) {
        return this.lobbyTables;
      }

      let items = [];

      if (!this.defaultValues.lobbyRowsDefaults) {
        return [];
      }

      let defaults = this.defaultValues.lobbyRowsDefaults.orderTables;
      if (!Array.isArray(defaults)) {
        return [];
      }

      defaults.forEach((tableId) => {
        let table = this.$store.getters['tablesForSelect/list'].filter(({ value }) => value === tableId.toString())[0];
        if (!table) {
          return;
        }
        items.push({ id: table.value, title: table.value + ' - ' + table.label });
      });

      return items;
    },
    actualLobbyTableGroups() {
      if (!this.useDefaultSettingsForLobby) {
        return this.lobbyTableGroups;
      }

      let items = [];

      if (!this.defaultValues.lobbyRowsDefaults) {
        return [];
      }

      let defaults = this.defaultValues.lobbyRowsDefaults.orderGroups;
      if (!Array.isArray(defaults)) {
        return [];
      }

      defaults.forEach((group) => {
        if (tableTypes.indexOf(group) === -1) {
          return;
        }

        items.push(group);
      });

      return items;
    },
    tableGroupList() {
      let options = [
        { value: 0, text: 'Add Table Type' }
      ];

      tableTypes.forEach((type) => {
        if (this.lobbyTableGroups.indexOf(type) !== -1) {
          return;
        }

        options.push({ value: type, text: type })
      });

      return options;
    },
    tableListForLobbyTables() {
      let options = [
        { value: 0, text: 'Add Table' }
      ];

      let usedIds = this.lobbyTables.map((item) => item.id);

      if (this.$store.getters['tablesForSelect/list']) {
        this.$store.getters['tablesForSelect/list'].forEach(({ value, label }) => {
          if (usedIds.indexOf(value) !== -1) {
            return;
          }

          options.push({ value, text: value + ' - ' + label })
        });
      }

      return options;
    },
    tableListForSkinMap() {
      const options = [
        { value: 0, text: 'Lobby' }
      ];

      if (this.$store.getters['tablesForSelect/list']) {
        this.$store.getters['tablesForSelect/list'].forEach(({ value, label }) => options.push({ value, text: value + ' - ' + label }));
      }

      return options;
    },
    backUrl() {
      return process.env.VUE_APP_BACK_URL;
    },
    cdnBackUrl() {
      return process.env.VUE_APP_CDN_BACK_URL;
    },
    detailsTabHasError() {
      if (this.validateState('name-input') === false) {
        return true;
      }

      if (this.validateState('api_version-input') === false) {
        return true;
      }

      return false;
    },
    apiTabHasError() {
      if (this.validateState('apiId-input') === false) {
        return true;
      }

      if (this.validateState('public-input') === false) {
        return true;
      }

      if (this.validateState('salt-input') === false) {
        return true;
      }

      if (this.validateState('useSignature-input') === false) {
        return true;
      }

      return false;
    },
    partnerOptions() {
      const options = [
        { value: null, text: '' }
      ];

      if (this.$store.getters['partnersForSelect/list']) {
        this.$store.getters['partnersForSelect/list'].forEach(({ value, label }) => options.push({ value, text: label }));
      }

      return options;
    },

    hideControlsOptions() {
      let options = [
        'Autobet',
        'Chat',
        'CompleteBet',
        'Favorites',
        'Fullscreen',
        'Exit',
        'Help',
        'History',
        'Language',
        'Lobby',
        'MiniLobby',
        'Stats',
        'Tournament',
        'Video',
        'Volume',
      ];

      return options.map(option => {
        return {
          value: option,
          text: option,
        };
      })
    },
    routeIcon: () => getRouteIcon(ROUTE_OPERATORS),
  },
  async beforeMount() {
  },
  mounted() {
  },
}
</script>
